import React from 'react';
import PropTypes from 'prop-types';
import ThinkingOrb from '../ThinkingOrb/ThinkingOrb';
import './Loading.scss';
import i18n from "../../../i18n";

const Loading = ({ name = i18n.t('loading.system_startup', 'Запуск системы...') }) => (
  <div className="loading-overlay">
    <div className="loading-glass-card">
      <ThinkingOrb size="lg" text={name} />
    </div>
  </div>
);

Loading.propTypes = {
  name: PropTypes.string,
};

export default Loading;